import Vue from 'vue'
import Router from 'vue-router'
import posRoutes from './modules/pos'
import authRoutes from './modules/auth'
import submodulesPos from './submodules/submodulesPos'
// Import Guard
import guard from '@/routes/guard/guard'

Vue.use(Router)

// Add submodules to Pos Routes
posRoutes[0].children = [...submodulesPos]

const router = new Router({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes: [...posRoutes, ...authRoutes],
})

// Global guard for router ( redirect to Login if user is not authenticated)
router.beforeEach(guard)

export default router
